<template>
  <div class="container-fluid">
    <div class="card">
      <loading :loading="isLoading" msg="Carregando oferta" />
      <div class="row" v-if="offer">
        <div class="col-sm-5">
          <b-carousel id="carousel-fade" style="text-shadow: 0px 0px 2px #000" fade indicators img-width="1024" img-height="480" v-model="slide">
            <b-carousel-slide v-for="(image, index) in offer.product_variation.images" :key="index" :img-src="baseUrl+image.url"></b-carousel-slide>
          </b-carousel>
          <div v-if="offer.product_variation.images.length > 1" class="offer_thumbs row">
            <div class="col-sm-3" v-for="(image, index) in offer.product_variation.images" :key="index">
              <a @click="setSlide(index)"><img class="thumbnail" :src="baseUrl+image.url" :class="{active: (slide == index)}"></a>
            </div>
          </div>
        </div>
        <div class="col-md-7 col-sm-7">
          <h2 class="title"> {{offer.product_variation.name}} </h2>
          <tags :tags="offer.product_variation.tags" />
          <br>
          <AddToCart :offer="offer" />
          <br>
          <div>
            <p class="pre-line">{{offer.product_variation.description}}</p>
            <div class="card mt-4">
              <div class="card-header">
                <h6 class="mb-0">
                  Envio e estocagem
                </h6>
              </div>
              <div>
                <div class="card-body">
                  <table class="product-info">
                    <tbody>
                      <tr v-if="offer.invoice_issuer">
                        <td>Emissor da nota fiscal:</td>
                        <th class="text-right">{{invoiceIssuer(offer.invoice_issuer)}}</th>
                      </tr>
                      <tr v-if="offer.address">
                        <td>Origem do envio:</td>
                        <th class="text-right">
                          <small v-if="offer.address">{{offer.address.description}}</small>
                        </th>
                      </tr>
                      <tr v-if="offer.product_variation.bar_code">
                        <td>
                          Data de fabricação:
                        </td>
                        <th class="text-right">
                          <div v-if="offer.manufacturing_date">
                            {{offer.manufacturing_date | moment("DD/MM/YYYY")}}
                          </div>
                          <div v-if="offer.product_variation && offer.product_variation.duration && offer.product_variation.duration.value && offer.manufacturing_date">
                            <small>Vence {{offer.manufacturing_date | moment("add", offer.product_variation.duration.value + ' ' + date_unit[offer.product_variation.duration.unit]) | moment('from', 'now')}}</small>
                          </div>
                        </th>
                      </tr>
                      <tr v-if="offer.product_variation.duration && offer.product_variation.duration.value">
                        <td>Validade:</td>
                        <th class="text-right">{{offer.product_variation.duration.value}} {{offer.product_variation.duration.unit}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.minimum_quantity_for_shipping && offer.product_variation.minimum_quantity_for_shipping.value">
                        <td>Quantidade mínima para envio:</td>
                        <th class="text-right">{{offer.product_variation.minimum_quantity_for_shipping.value}} {{offer.product_variation.minimum_quantity_for_shipping.unit}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.gross_weight && offer.product_variation.gross_weight.value">
                        <td>Peso bruto por unidade:</td>
                        <th class="text-right">{{offer.product_variation.gross_weight.value}} {{offer.product_variation.gross_weight.unit}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.net_weight && offer.product_variation.net_weight.value">
                        <td>Peso liquido por unidade:</td>
                        <th class="text-right">{{offer.product_variation.net_weight.value}} {{offer.product_variation.net_weight.unit}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.ncm">
                        <td>NCM:</td>
                        <th class="text-right">{{offer.product_variation.ncm}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.bar_code">
                        <td>Código de barras:</td>
                        <th class="text-right">{{offer.product_variation.bar_code}}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="card mt-4">
              <div class="card-header">
                <h6 class="mb-0">
                  Embalagem comercial
                </h6>
              </div>
              <div>
                <div class="card-body">
                  <table class="product-info">
                    <tbody>
                      <tr v-if="offer.product_variation.box_width && offer.product_variation.box_width.value">
                        <td>Peso da embalagem:</td>
                        <th class="text-right">{{offer.product_variation.box_width.value}} {{offer.product_variation.box_width.unit}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.box_height && offer.product_variation.box_height.value">
                        <td>Altura:</td>
                        <th class="text-right">{{offer.product_variation.box_height.value}} {{offer.product_variation.box_height.unit}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.box_length && offer.product_variation.box_length.value">
                        <td>Comprimento:</td>
                        <th class="text-right">{{offer.product_variation.box_length.value}} {{offer.product_variation.box_length.unit}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.box_gross_weight && offer.product_variation.box_gross_weight.value">
                        <td>Peso bruto:</td>
                        <th class="text-right">{{offer.product_variation.box_gross_weight.value}} {{offer.product_variation.box_gross_weight.unit}}</th>
                      </tr>
                      <tr v-if="offer.product_variation.box_max_stack">
                        <td>Empilhamento máximo:</td>
                        <th class="text-right">{{offer.product_variation.box_max_stack}}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="card mt-4" v-if="offer.supplier">
              <div class="card-header">
                <h6 class="mb-0">
                  Fornecedor
                </h6>
              </div>
              <div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <img class="img-thumbnail" :src="defaultThumb(offer.supplier.images)" :alt="offer.supplier.name">
                    </div>
                    <div class="col-md-9">
                      <h6><strong>{{offer.supplier.name}}</strong></h6>
                      <p><small>{{offer.supplier.history}}</small></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mt-4" v-if="offer.organization">
              <div class="card-header">
                <h6 class="mb-0">
                  Rede responsável
                </h6>
              </div>
              <div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <img class="img-thumbnail" :src="defaultThumb(offer.organization.images)" :alt="offer.organization.name">
                    </div>
                    <div class="col-md-9">
                      <h6><strong>{{offer.organization.name}}</strong></h6>
                      <p><small>{{offer.organization.history}}</small></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-4" v-if="relatedOffers.length">
          <div class="card-header">
            <h6>Produtos relacionados</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3" v-for="(offer, index) in relatedOffers" :key="index">
                <div class="card card-product card-plain no-shadow" data-colored-shadow="false">
                  <div class="card-header card-header-image">
                    <router-link :to="'/oferta/'+offer._id">
                      <div class="img-container">
                        <product-image :product="offer.product" :product_variation="offer.product_variation" css_class="product-image" />
                      </div>
                    </router-link>
                  </div>
                  <div class="card-body">
                    <router-link :to="'/oferta/'+offer._id">
                      <h4 class="card-title">{{offer.product_variation.name}}</h4>
                    </router-link>
                  </div>
                  <div class="card-footer">
                    <div class="price-container">
                      <span class="price">{{offer.final_price | moeda}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading";
import ProductImage from "@/components/ProductImage";
import AddToCart from "@/components/AddToCart";
import Tags from "@/components/Tags";

export default {
  name: "Offer",

  data() {
    return {
      offer: null,
      slide: 0,
      qtd: 1,
      relatedOffers: []
    };
  },

  async created() {
    this.fetchOffer();
  },
  computed: {
    alreadyOnCart() {
      var qtd = 0
      var cart = this.$store.state.cart
      if (cart && cart.length) {
        qtd = cart.filter(i => i.offer._id == this.offer._id).reduce((a, b) => {
          return a + b.qtd
        }, 0)
      }
      return qtd
    },
    availableQtd() {
      var qtd = 0
      if (this.offer) {
        qtd = this.offer.qtd - this.offer.qtd_ordered - this.alreadyOnCart
      }
      return qtd
    }
  },
  methods: {
    fetchOffer() {
      this.isLoading = true;

      axios
        .get("shop/offer/" + this.$route.params.id, {
          params: {
            populate: "product_variation supplier organization orders"
          }
        })
        .then(response => {
          this.offer = response.data;
          this.isLoading = false;
          this.fetchRelated();
        })
        .catch(this.showError);
    },
    fetchRelated() {
      axios
        .get("shop/offers")
        .then(({
          data
        }) => {
          this.relatedOffers = data
            .map(offer => {
              let similarity = 0;
              const {
                tags
              } = this.offer.product_variation;


              offer.product_variation.tags.forEach(tag => {
                if (tags.find(({
                    text
                  }) => text === tag.text)) {
                  similarity += 1;
                }
              });
              return {
                ...offer,
                similarity
              };
            })
            .filter(
              offer => offer._id !== this.offer._id && offer.similarity > 0
            )
            .sort((offerA, offerB) => offerB.similarity - offerA.similarity);
        })
        .catch(this.showError);
    },
    setSlide(slide) {
      this.slide = slide;
    }
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.fetchOffer();
      }
    }
  },
  components: {
    Loading,
    ProductImage,
    AddToCart,
    Tags
  }
};
</script>
<style lang="sass" scoped>
  .offer_thumbs
    padding: 10px
    > div
      padding: 5px
    img
      width: 100%
      &.active
        opacity: .5
    @media (max-width: 576px)
      display: none
</style>
